export const apiConfig = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    changePassword: '/auth/change-password',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    profile: '/auth/profile',
    menus: '/auth/menus'
  },
  crud: {
    base: '/entities'
  },
  openAccount: {
    list: '/open-account',
    delete: (srno) => `/open-account/${srno}`,
    exportExcel: '/open-account/export-excel',
  },
  contacts: {
    list: '/contacts',
    delete: (srno) => `/contacts/${srno}`,
    exportExcel: '/contacts/export-excel',
  },
  partner: {
    list: '/contacts/partner',
    delete: (srno) => `/contacts/partner/${srno}`,
    exportExcel: '/contacts/partner/export-excel',
  },
  callback: {
    list: '/contacts/callback',
    delete: (srno) => `/contacts/callback/${srno}`,
    exportExcel: '/contacts/callback/export-excel',
  },
  research: {
    list: '/research',
    detail: (srno) => `/research/${srno}`,
    create: '/research',
    update: (srno) => `/research/${srno}`,
    delete: (srno) => `/research/${srno}`,
    sections: '/research/sections',
    subsections: (sectionCode) => `/research/sections/${sectionCode}/subsections`
  },
  messageNotifications: {
    list: '/message-notifications',
    detail: (srno) => `/message-notifications/${srno}`,
    create: '/message-notifications',
    update: (srno) => `/message-notifications/${srno}`,
    delete: (srno) => `/message-notifications/${srno}`
  },
  downloads: {
    list: '/downloads',
    detail: (srno) => `/downloads/${srno}`,
    create: '/downloads',
    update: (srno) => `/downloads/${srno}`,
    delete: (srno) => `/downloads/${srno}`,
    sections: '/downloads/sections/admin',
    createSection: '/downloads/sections',
    updateSection: (srno) => `/downloads/sections/${srno}`,
    deleteSection: (srno) => `/downloads/sections/${srno}`,
    subsections: '/downloads/subsections/admin',
    createSubsection: '/downloads/subsections',
    updateSubsection: (srno) => `/downloads/subsections/${srno}`,
    deleteSubsection: (srno) => `/downloads/subsections/${srno}`
  },
  investors: {
    list: '/investors',
    detail: (srno) => `/investors/${srno}`,
    create: '/investors',
    update: (srno) => `/investors/${srno}`,
    delete: (srno) => `/investors/${srno}`,
    sections: '/investors/sections',
    sectionDetail: (srno) => `/investors/sections/${srno}`,
    createSection: '/investors/sections',
    updateSection: (srno) => `/investors/sections/${srno}`,
    deleteSection: (srno) => `/investors/sections/${srno}`
  },
  statutoryDocuments: {
    list: '/statutory-documents',
    detail: (srno) => `/statutory-documents/${srno}`,
    create: '/statutory-documents',
    update: (srno) => `/statutory-documents/${srno}`,
    delete: (srno) => `/statutory-documents/${srno}`
  },
  dpComplaints: {
    list: '/dp-complaints',
    detail: (srno) => `/dp-complaints/${srno}`,
    create: '/dp-complaints',
    update: (srno) => `/dp-complaints/${srno}`,
    delete: (srno) => `/dp-complaints/${srno}`,
    generatePdf: (srno) => `/dp-complaints/generate-pdf/${srno}`,
    current: '/dp-complaints/current',
    public: '/dp-complaints/public'
  },
  sebiComplaints: {
    list: '/sebi-complaints',
    detail: (srno) => `/sebi-complaints/${srno}`,
    create: '/sebi-complaints',
    update: (srno) => `/sebi-complaints/${srno}`,
    delete: (srno) => `/sebi-complaints/${srno}`,
    generatePdf: (srno) => `/sebi-complaints/generate-pdf/${srno}`,
    current: '/sebi-complaints/current',
    public: '/sebi-complaints/public'
  },
  testimonials: {
    list: '/testimonials',
    detail: (srno) => `/testimonials/${srno}`,
    create: '/testimonials',
    update: (srno) => `/testimonials/${srno}`,
    delete: (srno) => `/testimonials/${srno}`
  },
  popup: {
    get: '/admin/popup',
    create: '/admin/popup',
    update: (id) => `/admin/popup/${id}`,
    delete: (id) => `/admin/popup/${id}`,
    active: '/popup/active'
  }
};

export default apiConfig;